module.exports = __webpack_public_path__ + "img/bg-contato.d82a353d.webp";